import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link, Prices } from '@Hotels-at-Home/hah-fe-core/dist/components';
import HomeImage from '~/ui/pages/Home/common/HomeImage';
import { IPrices } from '@Hotels-at-Home/hah-fe-core/dist/utils/price';

interface IProps {
  title: string;
  description?: string;
  img: string;
  imgMobile: string;
  url: string;
  hasHoverCTA?: boolean;
  isFlipped?: boolean;
  loading?: 'eager' | 'lazy';
  prices?: IPrices;
}

interface StackImageContainerProps {
  title: string;
  img: string;
  imgMobile: string;
  loading: 'eager' | 'lazy';
  buttonText: string;
  hasHoverCTA?: boolean;
}

const StackImageContainer = ({
  title,
  img,
  imgMobile,
  loading,
  buttonText,
  hasHoverCTA = false,
}: StackImageContainerProps): ReactElement => (
  <div className="hp-stack-image">
    {hasHoverCTA ? (
      <div className="hover-btn-animation">
        <HomeImage ariaLabel={title} img={img} imgMobile={imgMobile} loading={loading} />
        <div className="hover-content desktop-only">
          <span className="btn base-btn btn-main">
            <span>{buttonText}</span>
          </span>
        </div>
      </div>
    ) : (
      <HomeImage ariaLabel={title} img={img} imgMobile={imgMobile} loading={loading} />
    )}
  </div>
);

const HomeStack = ({
  title,
  description,
  img,
  imgMobile,
  url,
  hasHoverCTA = false,
  isFlipped = false,
  loading = 'lazy',
  prices,
}: IProps): ReactElement => {
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  return (
    <div className="hp-stack">
      <Link href={url}>
        {isFlipped && (
          <StackImageContainer
            title={title}
            img={img}
            imgMobile={imgMobile}
            loading={loading}
            buttonText={tButton('shopNow')}
            hasHoverCTA={hasHoverCTA}
          />
        )}
        <div className="hp-stack-content">
          <h2 className="italic">{title}</h2>
          {prices?.newPrice && <Prices prices={prices} show />}
          {description && <p>{description}</p>}
          <Button variant="main">{tButton('shopNow')}</Button>
        </div>
        {!isFlipped && (
          <StackImageContainer
            title={title}
            img={img}
            imgMobile={imgMobile}
            loading={loading}
            buttonText={tButton('shopNow')}
            hasHoverCTA={hasHoverCTA}
          />
        )}
      </Link>
    </div>
  );
};

export default HomeStack;
